import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { ConfigurationService } from '../configuration.service';
import { Observable } from '../util/rxjs';
import { ServerVersion } from '../server-version.model';

@Component({
  selector: 'cp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {
  version$: Observable<ServerVersion>;

  constructor(private configurationService: ConfigurationService) {
  }

  ngOnInit() {
    this.version$ = this.configurationService.getVersion(false);
  }
}
